<template>
  <!-- The AI search mark. Coral by default; size it with width/height. -->
  <svg
    class="sparkle-icon"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path d="M12 2.5c.4 4.6 2.9 7.1 7.5 7.5-4.6.4-7.1 2.9-7.5 7.5-.4-4.6-2.9-7.1-7.5-7.5 4.6-.4 7.1-2.9 7.5-7.5Z" />
    <path d="M19 15.5c.2 2 1.3 3.1 3.3 3.3-2 .2-3.1 1.3-3.3 3.3-.2-2-1.3-3.1-3.3-3.3 2-.2 3.1-1.3 3.3-3.3Z" />
  </svg>
</template>

<script>
export default {
  name: 'SparkleIcon'
}
</script>

<style scoped lang="scss">
@import "../assets/scss/_variables.scss";

.sparkle-icon {
  display: inline-block;
  flex: none;
  fill: $red;
}
</style>
